import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';

/** True once the platform is collecting sales tax (STRIPE_TAX_ENABLED on the backend). */
/** null while still loading, so callers can wait instead of guessing 'no tax'. */
export function useTaxEnabled() {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem('token');
    axios
      .get(`${API}/tax/types`, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then(r => setEnabled(!!r.data.enabled))
      .catch(() => setEnabled(false));
  }, []);
  return enabled;
}

/** Billing address object Stripe Tax needs — country + ZIP is enough in the US. */
export function billingAddressFor(zip) {
  const clean = (zip || '').trim();
  return clean ? { country: 'US', postal_code: clean } : null;
}

/**
 * Minimal ZIP field for flows with no shipping address. Two themes so it sits
 * naturally on both the cream marketplace surfaces and the dark dashboard modals.
 */
export function BillingZipField({ value, onChange, theme = 'light', testId = 'billing-zip-input' }) {
  const dark = theme === 'dark';
  return (
    <div style={{ marginBottom: 14 }}>
      <label
        style={{
          display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 6,
          color: dark ? '#cbd5e1' : '#5a4a3a',
        }}
      >
        Billing ZIP code
      </label>
      <input
        value={value}
        onChange={e => onChange(e.target.value.replace(/[^0-9-]/g, '').slice(0, 10))}
        placeholder="54986"
        inputMode="numeric"
        data-testid={testId}
        style={{
          width: 140, padding: '10px 12px', borderRadius: 10, fontSize: 14,
          color: dark ? '#e2e8f0' : '#000000',
          background: dark ? 'rgba(255,255,255,0.06)' : '#fffdf8',
          border: `1px solid ${dark ? 'rgba(255,255,255,0.15)' : '#e4dbcd'}`,
          outline: 'none',
        }}
      />
      <p style={{ fontSize: 11, color: dark ? '#94a3b8' : '#a09080', margin: '6px 0 0' }}>
        Used only to calculate sales tax for your state.
      </p>
    </div>
  );
}
